'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusReactElement = focusReactElement;
exports.isVisibleInViewPort = isVisibleInViewPort;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.isCurrentUrl = isCurrentUrl;
exports.getTextFromPasteEvent = getTextFromPasteEvent;
exports.fixedEncodeURIComponent = fixedEncodeURIComponent;
exports.getScrollTop = getScrollTop;
exports.getActiveElement = getActiveElement;

var _cookie = require('cookie');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _tabbable = require('tabbable');

var _tabbable2 = _interopRequireDefault(_tabbable);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function focusReactElement(element) {
  var _element = _reactDom2.default.findDOMNode(element); // eslint-disable-line react/no-find-dom-node

  if (_element) {
    var tabbableElements = (0, _tabbable2.default)(_element);

    // Focus the first heading if there is one, otherwise focus the first element
    var elementToFocus = _element.querySelector('h1, h2, h3, h4, h5, h6') || tabbableElements[0];

    if (elementToFocus) {
      if (!(0, _lodash.includes)(tabbableElements, elementToFocus)) {
        // Give the element a tabindex of -1 if it isn't a tabbable element already
        // Otherwise, it's not focusable
        elementToFocus.setAttribute('tabIndex', -1);
      }
      elementToFocus.focus();
    }
  }
}

function isVisibleInViewPort(el) {
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 || rect.bottom >= 0;
}

/**
 * Gets the value of the cookie at `key`.
 * @param  {string} key
 * @return {string}
 */
function getCookie(key) {
  if (!document) return undefined;
  return (0, _cookie.parse)(document.cookie)[key];
}

/**
 * Sets a document cookie with the given args.
 * @see https://github.com/jshttp/cookie#serialize
 *
 * @param {string} key
 * @param {string} val
 * @param {object} opts
 */
function setCookie(key, val, opts) {
  if (!document) return;
  document.cookie = (0, _cookie.serialize)(key, '' + val, opts);
}

var urlWithoutHash = function urlWithoutHash(url) {
  var hashIndex = url.lastIndexOf('#');
  return url.substring(0, hashIndex >= 0 ? hashIndex : url.length);
};

/**
 * Checks if the URL is the same as the browser's current URL
 *
 * @param {string} url
 */
function isCurrentUrl(url) {
  return urlWithoutHash(url) === urlWithoutHash(window.location.href);
}

function getTextFromPasteEvent(e) {
  if (e.clipboardData) {
    try {
      return e.clipboardData.getData('text/plain');
    } catch (err) {
      // IE11 does not support "text/plain", but does support "text".
      return e.clipboardData.getData('text');
    }
  }

  return null;
}

/**
 * Encodes additional special characters in the string value passed
 *
 * @param {string} str
 * Resource: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
 */

function fixedEncodeURIComponent(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16);
  });
}

function getScrollTop() {
  if (window && document) {
    // See http://stackoverflow.com/questions/28633221/document-body-scrolltop-firefox-returns-0-only-js
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  return 0;
}

/**
 * @desc Handles retrieving activeElement correctly from document; created to handle ie11 inside of an iframe
 * modified from: https://gist.github.com/Alex1990/046a6553dc83e22dd6f4
 * @param {HTMLDocument} document
 * @return {HTMLElement}
 */
function getActiveElement(document) {
  var activeElement = void 0;

  try {
    activeElement = document.activeElement;
    if (!activeElement || !activeElement.nodeName) {
      activeElement = document.body;
    }
  } catch (error) {
    activeElement = document.body;
  }

  return activeElement;
}


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/utils/browser/lib/index.js
// module id = 376
// module chunks = 0 1 2 3 5 6 7